import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";
import * as React from "react";
import * as ReactDOM from "react-dom";
import { ReactEditor, useSlate } from "slate-react";

import { ICannedResponseTag } from "components/message-box/canned-responses";
import { StackingContextLevel } from "styles/stacking-context-level";

const CannedResponsesUI: React.FC<{
  cannedWindowRef: React.RefObject<HTMLDivElement>;
  cannedResponses: ICannedResponseTag[];
  children: React.ReactNode;
}> = ({ cannedWindowRef, cannedResponses, children }) => {
  const editor = useSlate();
  const containerRef = useRef<HTMLDivElement>(null);
  const [portalCreated, togglePortalCreated] = useState(false);
  const positionInterface = useCallback(() => {
    const cannedResponseRange = editor.cannedResponsesAPI.range();

    if (containerRef.current && cannedResponseRange) {
      const target = containerRef.current;
      const cannedWidget = cannedWindowRef.current;
      const domRange = ReactEditor.toDOMRange(editor, cannedResponseRange);

      const cannedBox = cannedWidget?.getBoundingClientRect();
      const rangeBox = domRange.getBoundingClientRect();

      const leftCorrection = Math.max(0, rangeBox.left + (cannedBox?.width ?? 0) - window.innerWidth);

      target.style.left = `${Math.max(0, rangeBox.left - leftCorrection) + window.scrollX}px`;
      target.style.top = `${Math.max(0, rangeBox.top - (cannedBox?.height ?? 0)) + window.scrollY - 6}px`;
    }
  }, []);

  const onCannedResponsesUpdate = useCallback(() => {
    positionInterface();
  }, [positionInterface]);

  const setupSpacesAllowed = useCallback(() => {
    const maxSpaces = Math.max(...cannedResponses.map(response => response.name.split(/\s/).length));

    editor.cannedResponsesAPI.setAllowedSpaces(maxSpaces);
  }, [cannedResponses]);

  useEffect(() => {
    const newPortal = document.createElement("div");
    newPortal.className = "canned-responses-portal";
    document.body.appendChild(newPortal);
    togglePortalCreated(true);

    return (): void => {
      const toRemovePortal = document.querySelector(".canned-responses-portal");
      if (toRemovePortal) document.body.removeChild(toRemovePortal);
    };
  }, []);

  useEffect(() => {
    document.addEventListener("canned_responses_updated", onCannedResponsesUpdate);
    window.addEventListener("resize", onCannedResponsesUpdate);

    return (): void => {
      document.removeEventListener("canned_responses_updated", onCannedResponsesUpdate);
      window.removeEventListener("resize", onCannedResponsesUpdate);
    };
  }, []);

  useLayoutEffect(() => {
    positionInterface();
    setupSpacesAllowed();
  });

  return portalCreated
    ? ReactDOM.createPortal(
        editor.cannedResponsesAPI.active() ? (
          <div ref={containerRef} style={{ position: "absolute", zIndex: StackingContextLevel.Tooltip }}>
            {children}
          </div>
        ) : null,
        // @ts-expect-error TS(2345): Argument of type 'Element | null' is not assignabl... Remove this comment to see the full error message
        document.querySelector(".canned-responses-portal")
      )
    : null;
};

export default CannedResponsesUI;
